export type OnboardingStep = 'name' | 'about' | 'calendar' | 'permissions';

export type UseCase = 'work' | 'school' | 'personal';

export interface OnboardingData {
  name: string;
  useCase: UseCase | null;
  referralSource: string | null;
}

export const EMPTY_ONBOARDING: OnboardingData = {
  name: '',
  useCase: null,
  referralSource: null,
};
